import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { zitchaMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getCurrencyISOCode } from '@as-react/common-utils';
import { convertToCurrencySymbol } from '../util/CurrencyUtil';
const pageViewId = uuid();
export const useZitcha = () => {
    const { defaultRequestParams, servicesEndpoint, thirdparty } = useAemConfig();
    const { postAnalytics } = zitchaMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: postAnalyticsMutation } = useMutation(postAnalytics());
    const collectConversion = useCallback((order) => __awaiter(void 0, void 0, void 0, function* () {
        if (!order) {
            return;
        }
        const fp = yield FingerprintJS.load();
        const { visitorId } = yield fp.get();
        return postAnalyticsMutation({
            event: 'conversions',
            data: {
                action: 'sale',
                customerIdentifiers: [
                    {
                        type: 'device_fingerprint',
                        system: 'local',
                        value: visitorId,
                    },
                ],
                basket: {
                    currency: getCurrencyISOCode(convertToCurrencySymbol(order.currency)),
                    value: order.priceTotalBasket,
                    products: order.mappedProducts.map(product => ({
                        productId: `${product.sku}`,
                        productName: product.description,
                        pricePaid: product.price,
                        quantity: product.quantity,
                    })),
                },
                conversionId: order.orderNumber,
                pageLocation: window === null || window === void 0 ? void 0 : window.location.href,
                retailerOrderId: order.orderNumber,
                source: 'web',
            },
        });
    }), []);
    const collectClick = (_a) => __awaiter(void 0, [_a], void 0, function* ({ adFormat, adId, placementId }) {
        const fp = yield FingerprintJS.load();
        const { visitorId } = yield fp.get();
        return postAnalyticsMutation({
            event: 'ad-clicks',
            data: {
                adFormat,
                adId,
                clickId: uuid(),
                customerIdentifiers: [
                    {
                        type: 'device_fingerprint',
                        system: 'local',
                        value: visitorId,
                    },
                ],
                placementId,
                pageViewId,
                pageLocation: window === null || window === void 0 ? void 0 : window.location.href,
                source: 'web',
            },
        });
    });
    const collectImpression = (_a) => __awaiter(void 0, [_a], void 0, function* ({ adFormat, adId, placementId }) {
        const fp = yield FingerprintJS.load();
        const { visitorId } = yield fp.get();
        return postAnalyticsMutation({
            event: 'ad-impressions',
            data: {
                adFormat,
                adId,
                customerIdentifiers: [
                    {
                        type: 'device_fingerprint',
                        system: 'local',
                        value: visitorId,
                    },
                ],
                pageViewId,
                pageLocation: window === null || window === void 0 ? void 0 : window.location.href,
                placementId,
                source: 'web',
            },
        });
    });
    const collectPageview = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!thirdparty.zitcha.isEnabled) {
            return;
        }
        const fp = yield FingerprintJS.load();
        const { visitorId } = yield fp.get();
        return postAnalyticsMutation({
            event: 'page-view',
            data: {
                customerIdentifiers: [
                    {
                        type: 'device_fingerprint',
                        system: 'local',
                        value: visitorId,
                    },
                ],
                pageViewId: pageViewId,
                pageLocation: window === null || window === void 0 ? void 0 : window.location.href,
                source: 'web',
            },
        });
    });
    return {
        collectConversion,
        collectClick,
        collectImpression,
        collectPageview,
    };
};
